import { ReelWin } from "./ReelWin";

import { spinData } from '../server/getServerResposesFun';

import { betValueGlobal, RespinIndex } from "../config/GlobalVariableConfig";

import { casinoEventEmitter } from "../core/CasinoChannelHandler";
import { reelSpinEmitter } from "./ReelInit";


export class Reels extends ReelWin {



    constructor() {
        super();

    }

    public update() {

        this.updateReelWin()
    }



    private resetReelRunning(spinStype: string) {
        // this.running = true;
        reelSpinEmitter.emit("resetWins");
        if (spinStype === "BASE") {
            console.log("inside resetReelRunning Base")
            RespinIndex.reset();

        }

        console.log("currentRespinIndex", RespinIndex.value, spinStype);

        this.resetReelOverlayContFromToggle();

    }


    public async startPlay(spinStype: string): Promise<[number, number, number?, boolean?]> {

        // Cleanup any existing listeners for 'betDeclined' before adding a new one
        casinoEventEmitter.removeAllListeners('betDeclined');

        // Create a promise that resolves when 'betDeclined' is emitted
        const betDeclinedPromise = new Promise((resolve) => {
            // 'once' ensures automatic cleanup after the event is handled
            casinoEventEmitter.once('betDeclined', () => resolve('BetDeclined'));
        });

        console.log("startPlay for Freegame", this.running, spinStype, RespinIndex.value, spinData.respins.length);

        this.resetReelRunning(spinStype);

        let freeGameTrigger = 0;
        let accumulatedsWinAmount = 0;
        let respinWin: number = 0;
        let isFeatureTrigger: boolean = false;

        do {
            console.log("startPlay for Freegame", "inside do-while", RespinIndex.value);

            const respinType = RespinIndex.value === 0 ? "reveal" : spinData.respins[RespinIndex.value].type;
            console.log("respinType", respinType);

            if (respinType === "feature_enter") {
                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;
                console.log(`feature_enter triggered: ${freeGameTrigger}`);
                // this.running = false;

                const accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                RespinIndex.increase();

                return [freeGameTrigger, accumulatedsWinAmount];
            }
            else if (respinType === "feature_exit" || respinType === "max_win_reached") {
                freeGameTrigger = -1;
                const totalFeatureWin = spinData.respins[RespinIndex.value].accumulatedsWinAmount || 0;
                console.log(`Feature end triggered: ${freeGameTrigger}`);
                // this.running = false;
                RespinIndex.increase();


                if (respinType === "max_win_reached") {
                    // this.resetReelsMaxWin();
                    freeGameTrigger = -2;
                }

                // casinoChannel.publish('showMaxWinDialog');

                return [freeGameTrigger, totalFeatureWin, totalFeatureWin];
            }
            else if (respinType === "reveal" || respinType === "battleRespin" || respinType === "fs_reveal" || respinType === "fs_battleRespin") {

                const isNewSpin: boolean = (respinType === "reveal" || respinType === "fs_reveal");


                if (!isNewSpin) {

                }

                // Race between the reels and the 'betDeclined' event
                const betPromiseResult = await Promise.race([
                    this.startReels(RespinIndex.value, isNewSpin, spinStype), // Reel logic
                    betDeclinedPromise, // Event bet decline
                ]);

                if (betPromiseResult === 'BetDeclined') {
                    console.log('Bet was declined, breaking out of startPlay.');
                    this.resetReelRunning(spinStype);

                    this.isBetDecline = true;
                    return [0, -1];
                }

                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;

                await this.animateAllWinningSymbols(RespinIndex.value); // this is just marking the winning symbol, not animating symbols here

                const currentWin = spinData.respins[RespinIndex.value].winAmount;
                if (currentWin >= 10 * betValueGlobal /*&& currentWin < 20 * betValueGlobal*/) {

                    reelSpinEmitter.emit('animateCharacter', 'win_2');
                }


                if (isNewSpin) {
                    respinWin = 0;
                    // this.setAccWinValue(0);
                }

                respinWin += spinData.respins[RespinIndex.value].winAmount;

                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                // Check for fs_battleRespin sequence end in free games
                if ((spinStype === "FREEGAME") &&
                    (respinType === "fs_reveal" || respinType === "fs_battleRespin") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "fs_battleRespin") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "max_win_reached")
                ) {

                    // this.running = false;
                    RespinIndex.increase();

                    return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                }
            }
            else {
                //await this.triggerOtherFeatures();
                isFeatureTrigger = true;
                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;
                respinWin = spinData.respins[RespinIndex.value].winAmount;
                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;
                //RespinIndex.increase();
                console.log(`Respin for index ${RespinIndex.value}`);
                console.log("isFeatureTrigger " + isFeatureTrigger);
                return [freeGameTrigger, respinWin, accumulatedsWinAmount, isFeatureTrigger]

            }

            RespinIndex.increase();
            console.log(`Respin is done for index ${RespinIndex.value}`);

        } while (RespinIndex.value < spinData.respins.length);

        return [freeGameTrigger, accumulatedsWinAmount];  // Return final result if loop completes without early return
    }
}
